
        import { PAGE } from '/src/util/page.ts';
        import { SOURCE } from '/src/util/source.ts';
        if (typeof document !== 'undefined') {
            const container = document.getElementById('container');
            const rateQuote = document.createElement('rate-quote-app');
            const params = new URLSearchParams(window.location.search);
            const agent = {
                firstName: 'Michael',
                lastName: 'Jordan',
                email: 'mj@spacejam.com',
                producerNumber: 'P001234',
            };
            const sourceParam = params.get('source');
            const pageParam = params.get('page');
            const planIdParam = params.get('planId');

            const source = SOURCE.DIRECT_SHOPPER;
            const page = 'results';

            // const source = Object.values(SOURCE).includes(sourceParam)
            //     ? sourceParam
            //     : SOURCE.DIRECT_SHOPPER;
            // const page = Object.values(PAGE).includes(pageParam) ? pageParam : PAGE.RESULTS;

            Object.assign(rateQuote, {
                // agent,
                // source,
                // page,
                // planIds: planIdParam ? [planIdParam] : undefined,
                // data: exampleBackendResponse
            });
            if (container) {
                container.appendChild(rateQuote);
            }
        }
    